export const CHRISTINA_EMAIL = "christinajones@outlook.de"
export const CHRISTINA_PHONE = "+49 1575 0761136"
export const CHRISTINA_STREET = "Tiroler Straße 101"
export const CHRISTINA_ZIP_CITY = "60596 Frankfurt am Main"
export const S_SCHNIER_EMAIL = "s.schnier@em.uni-frankfurt.de"